module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/01df1f42be04d3a9f3a786e5615400c3.png";